function Excel(props: any) {
    return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M5.25 21.75V2.25H13.5V7.5H18.75V21.75H5.25ZM15 0H5.25H3V2.25V21.75V24H5.25H18.75H21V21.75V6L15 0ZM7.58906 10.5L10.6406 15L7.58906 19.5H10.3078L12 17.0016L13.6922 19.5H16.4109L13.3594 15L16.4109 10.5H13.6922L12 12.9984L10.3078 10.5H7.58906Z" />
            </svg> 
            );
}

export default Excel;